import React, { Component, Fragment } from 'react'
import CSSModules from 'react-css-modules'
import UserInput from 'components/custom/UserInputSelection/index'
import styles from '../styles.scss'


class RolesSelectionPage extends Component {
  constructor(props) {
    super(props);
    this.productRoles = [
      {label: 'Product Applications Engineer', key: 'productApplicationsEngineer'},
      {label: 'Applications Engineering Director', key: 'applicationsEngineeringDirector'},
      {label: 'Product Manager', key: 'productManager'},
      {label: 'Software Program Manager', key: 'softwareProgramManager'},
    ]
  }

  skuRolesRenderer = () => {
    const {
      employeeList,
      fetchEmployeeList,
      isLoading,
      productDetails,
      handleChange
    } = this.props

    return (
      <Fragment>
        <h5>Select Product Roles</h5>
        {this.productRoles.map(({label, key}) => 
          (<UserInput
            key={key}
            multi
            label={label}
            options={employeeList}
            onInputChange={fetchEmployeeList}
            onChange={(value) => handleChange(key, value)}
            value={productDetails[key]}
            isLoading={isLoading}
          />)
        )}
      </Fragment>
    )
  }

  render() {
    return (
      <React.Fragment>
        {this.skuRolesRenderer()}
      </React.Fragment>
    )
  }
}

export default CSSModules(RolesSelectionPage, styles)
